/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../../Image/HouseKeeping/Housekeeping1.png";


const EngineeringTechnicalContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Engineering & Technical Maintenance</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
          Densat provides technical manpower for preventive and breakdown maintenance across electrical, HVAC, plumbing and general repair systems. Our technicians perform routine checks, logbook updates, safety verifications and basic DG/UPS operations to ensure smooth facility performance.
        </p>

        <p>
         We help organisations reduce downtime, extend equipment life and maintain compliance with safety standards. From lighting fixtures to AHUs and plumbing lines, our teams work proactively to stabilise operations and keep the building functioning efficiently.
        </p>

        <p>
         Our hard services ensure that your critical building systems operate reliably, reducing emergency breakdowns and creating a safe, comfortable environment for occupants.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default EngineeringTechnicalContent;
